/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';

/**
 * 
 * @export
 * @interface ConsultantViewModel2
 */
export interface ConsultantViewModel2 {
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel2
     */
    firstNames?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel2
     */
    surname?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof ConsultantViewModel2
     */
    countryCode?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel2
     */
    countryDialingCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel2
     */
    contactNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel2
     */
    emailAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConsultantViewModel2
     */
    isExternalSource?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConsultantViewModel2
     */
    emailCCRecipientId: number;
}

/**
 * Check if a given object implements the ConsultantViewModel2 interface.
 */
export function instanceOfConsultantViewModel2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "emailCCRecipientId" in value;

    return isInstance;
}

export function ConsultantViewModel2FromJSON(json: any): ConsultantViewModel2 {
    return ConsultantViewModel2FromJSONTyped(json, false);
}

export function ConsultantViewModel2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsultantViewModel2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstNames': !exists(json, 'FirstNames') ? undefined : json['FirstNames'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'countryCode': !exists(json, 'CountryCode') ? undefined : IAPCOUNTRYFromJSON(json['CountryCode']),
        'countryDialingCode': !exists(json, 'CountryDialingCode') ? undefined : json['CountryDialingCode'],
        'contactNumber': !exists(json, 'ContactNumber') ? undefined : json['ContactNumber'],
        'emailAddress': !exists(json, 'EmailAddress') ? undefined : json['EmailAddress'],
        'isExternalSource': !exists(json, 'IsExternalSource') ? undefined : json['IsExternalSource'],
        'emailCCRecipientId': json['EmailCCRecipientId'],
    };
}

export function ConsultantViewModel2ToJSON(value?: ConsultantViewModel2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FirstNames': value.firstNames,
        'Surname': value.surname,
        'CountryCode': IAPCOUNTRYToJSON(value.countryCode),
        'CountryDialingCode': value.countryDialingCode,
        'ContactNumber': value.contactNumber,
        'EmailAddress': value.emailAddress,
        'IsExternalSource': value.isExternalSource,
        'EmailCCRecipientId': value.emailCCRecipientId,
    };
}

